import BlockHeader from 'components/common/BlockHeader';
import Button from 'components/common/Button';
import RadioField from 'components/OrderAggregators/components/RadioField';
import Colors from 'constants/colors';
import DeliveryPreferred from 'constants/delivery-preferred';
import DeliveryPreferredDuration from 'constants/delivery-preferred-duration';
import MediaBorders from 'constants/media-borders';
import MultiPaymentResultCodes from 'constants/multi-payment-result-codes';
import PaymentType from 'constants/payment-type';
import { PreferredDeliveryTime } from 'constants/preferred-delivery-time';
import i18n from 'i18n';
import moment from 'moment';
import React from 'react';
import { Form } from 'react-final-form';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import multipaymentManager from 'util/multipayment';
import SessionManager from 'util/session-manager';
import FixedArea from '../components/FixedArea';
import OrderAggregatorsHeader from '../components/Header';
import Bank from './components/Bank';
import Credit from './components/Credit';
import Customer from './components/Customer';
import Delivery from './components/Delivery';

class Payment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false
    };
  }

  restoreData = () => {
    let savedData;
    try {
      savedData = SessionManager.load();
    } catch (error) {
      switch (error.name) {
        case 'NoSessionError':
        case 'SessionExpiredError':
        case 'LoadDataError':
          this.props.push('/error');
          break;

        default:
          throw error;
      }
    }

    return savedData;
  };

  componentDidMount() {
    this.savedData = this.restoreData();

    if (this.savedData) {
      const { defaultDay } = this.savedData.masterData.delivery;
      this.datepickerMin = moment()
        .startOf('day')
        .add(moment.duration(defaultDay));
      // INFO 配送遅延対応(ハードコード)
      const shortestDate = '2020-07-13';
      if (shortestDate && this.datepickerMin.isBefore(shortestDate, 'day')) {
        this.datepickerMin = moment(shortestDate).startOf('day');
      }
      this.datepickerMax = this.datepickerMin
        .clone()
        .add(DeliveryPreferredDuration);

      if (!this.savedData.customer || !this.savedData.deliveries) {
        this.initialValues = {
          customer: {
            name: '',
            nameKana: '',
            telephone: '',
            email: ''
          },
          payment: {
            type: PaymentType.card,
            payerName: ''
          },
          deliveries: {
            deliveryPreferred: DeliveryPreferred.off,
            preferredDate: this.datepickerMin.format(
              i18n.t('common:dateFormat.default')
            ),
            preferredTime: PreferredDeliveryTime.morning
          }
        };
      } else {
        const { customer, payment, deliveries } = this.savedData;
        this.initialValues = {
          customer,
          payment,
          deliveries
        };
      }
      this.setState({
        loaded: true
      });
      // 他のページからの遷移の際にはaerosmith.init()する
      // このページの新規読み込み（リロード等）の場合はdidMountのタイミングではwindow.aerosmithが初期化されていない
      if (window.aerosmith !== undefined) {
        window.aerosmith.init()
      }
    }
  }

  getCost() {
    return this.savedData.cost;
  }

  getOrders() {
    return this.savedData.orders;
  }

  componentDidUpdate(prevProps) {
    if (this.props.error && prevProps.error == null) {
      const {
        showAlert,
        error: {
          data: { message }
        }
      } = this.props;
      showAlert(message);
    }
  }

  async handleClickNext(values) {
    const { push, showAlert } = this.props;

    const {
      customer,
      payment: { type, payerName },
      deliveries
    } = values;

    if (type === PaymentType.card) {
      const tokenRequestParams = {
        cardno: values.payment.cardno,
        holdername: values.payment.holdername.toUpperCase(),
        securitycode: values.payment.securitycode,
        expire: moment([
          values.payment.expiresYear,
          values.payment.expiresMonth - 1
        ]).format(i18n.t('common:dateFormat.creditCardExpires'))
      };

      const savedData = this.savedData
      const submitPayment = function () {
        multipaymentManager.init();
        multipaymentManager.getToken(tokenRequestParams, res => {
          const resultCode = String(res.resultCode);
          if (resultCode === MultiPaymentResultCodes.success) {
            SessionManager.save({
              ...savedData,
              customer,
              deliveries,
              payment: {
                type,
                creditToken: res.tokenObject.token,
                maskedCardNo: res.tokenObject.maskedCardNo
              }
            });
            return push('/order-aggregators/confirmation');
          } else {
            const errorCode = MultiPaymentResultCodes.errorCodes.includes(
              resultCode
            )
              ? resultCode
              : 'others';
            showAlert(
              i18n.t(
                `orderAggregators:payment:multiPaymentErrorMessages.${errorCode}`
              )
            );
          }
        });
      }
      
      try {
        // aerosmith.initはaerosmith読み込み時に行われているので実行しなくてもよい
        window.aerosmith.checkScore(function() {
          submitPayment()
        }, function(reason) {
          // 失敗した際はダイアログを閉じるのみなので何もしない
          if (reason === 'timeout') {
            console.log('[AerosmithService] this.object.checkScore -> filed -> ' + reason);
          } else if (reason === 'failed') {
            console.log('[AerosmithService] this.object.checkScore -> filed -> ' + reason);
          }
        });
      } catch (ex) {
        submitPayment()
      }
    } else {
      SessionManager.save({
        ...this.savedData,
        customer,
        deliveries: {
          ...deliveries,
          deliveryPreferred: DeliveryPreferred.off
        },
        payment: {
          type,
          payerName
        }
      });
      return push('/order-aggregators/confirmation');
    }
  }

  render() {
    const {
      className,
      match: { path },
      goBack
    } = this.props;

    return (
      this.state.loaded && (
        <div className={className}>
          <OrderAggregatorsHeader path={path} />
          <div className="order-aggregators-container">
            <Form
              onSubmit={value => this.handleClickNext(value)}
              initialValues={this.initialValues}
              render={({
                handleSubmit,
                submitting,
                hasValidationErrors,
                form
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="stretch-area">
                    <Customer change={form.change} orders={this.getOrders()} />

                    <hr className="splitter" />

                    <BlockHeader id="payment-info">
                      {i18n.t('orderAggregators:payment:payment.header')}
                    </BlockHeader>

                    <RadioField
                      name="payment.type"
                      labels={[
                        i18n.t('orderAggregators:payment:payment.card.select'),
                        i18n.t('orderAggregators:payment:payment.bank.select')
                      ]}
                      values={[PaymentType.card, PaymentType.bank]}
                    />
                    {!+form.getState().values.payment.type ? (
                      <Credit change={form.change} />
                    ) : (
                      <Bank change={form.change} />
                    )}
                    <hr className="splitter" />
                    <Delivery
                      existsFormInput={!+form.getState().values.payment.type}
                      datepickerMin={this.datepickerMin}
                      datepickerMax={this.datepickerMax}
                      {...form}
                    />
                    <Button
                      className="back-button"
                      buttonType="F-back"
                      type="button"
                      onClick={goBack}
                    >
                      {i18n.t('orderAggregators:payment:back')}
                    </Button>
                  </div>
                  <FixedArea
                    buttonText={i18n.t('orderAggregators:payment:submit')}
                    cost={this.getCost()}
                    disabled={hasValidationErrors || submitting}
                  />
                </form>
              )}
            />
          </div>
        </div>
      )
    );
  }
}

const commonStyle = css`
  form {
    margin: 0 auto;
    max-width: ${MediaBorders.large};

    .splitter {
      border: 0;
      border-top: 1px solid ${Colors.gray3};
      margin-top: 72px;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .order-aggregators-container {
    max-width: 1366px;
    padding: 72px 80px 160px;
    margin: 0 auto;
  }

  form {
    display: flex;

    .stretch-area {
      width: 762px;
      margin-right: 136px;
    }
  }

  .back-button {
    margin-top: 64px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .order-aggregators-container {
    padding: 0;

    .splitter {
      border: 0;
      border-top: 1px solid ${Colors.gray3};
      margin: 32px 16px 0;
    }

    .stretch-area {
      margin-bottom: 32px;

      ${BlockHeader},
      ${RadioField} {
        margin-left: 16px;
        margin-right: 16px;
      }
    }

    .back-button {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 96px;
      margin: 0 auto;
    }

    ${FixedArea} {
      .button-wrapper {
        margin-bottom: 136px;
      }
    }
  }
`;

export default applyStyles(Payment)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Payment/index.js